import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";

import {
  ICreateComissaoCorretora,
  ICreateComissaoProdutor,
  IValuesFilterComissaoCorretora,
  IValuesFilterComissaoProdutor,
} from "../ComissoesTypes";

export const valuesDefaultFilterComissaoCorretora: IValuesFilterComissaoCorretora = {
  codeOperadora: "",
  name: "",
  isActive: "TRUE",
};

export const valuesDefaultFilterComissaoProdutor: IValuesFilterComissaoProdutor =
{
  codeOperadora: "",
  name: "",
  isActive: "TRUE",
  funcao_produtor: "ALL",
  tipo_produtor: "ALL",
};

export const valuesDefaultInputsComissaoCorretora: ICreateComissaoCorretora = {
  name: "",
  vitalicio: "NONE",
  date_vigencia: `${GetDateUSSemValue()}`,

  parc_1: "0",
  parc_2: "0",
  parc_3: "0",
  parc_4: "0",
  parc_5: "0",
  parc_6: "0",
  parc_7: "0",
  parc_8: "0",
  parc_9: "0",
  parc_10: "0",
  parc_11: "0",
  parc_12: "0",
};

export const valuesDefaultInputsComissaoProdutor: ICreateComissaoProdutor = {
  name: "",
  date_vigencia: `${GetDateUSSemValue()}`,
  funcao_produtor: "CORRETOR",
  tipo_produtor: "SALAO",

  is_special: "false",

  vitalicio: "NONE",

  parc_1: "0",
  parc_2: "0",
  parc_3: "0",
  parc_4: "0",
  parc_5: "0",
  parc_6: "0",
  parc_7: "0",
  parc_8: "0",
  parc_9: "0",
  parc_10: "0",
  parc_11: "0",
  parc_12: "0",
};
